var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContactPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.70399 9.53106C6.35066 12.7672 9.00362 15.4202 12.2398 17.0668L14.7555 14.5511C15.0757 14.2309 15.5217 14.1394 15.9219 14.2652C17.2026 14.6883 18.5749 14.917 20.0043 14.917C20.3075 14.917 20.5984 15.0375 20.8129 15.252C21.0273 15.4664 21.1478 15.7573 21.1478 16.0605V20.0629C21.1478 20.3661 21.0273 20.657 20.8129 20.8715C20.5984 21.0859 20.3075 21.2064 20.0043 21.2064C14.8485 21.2064 9.90392 19.1583 6.25824 15.5126C2.61257 11.8669 0.564453 6.92233 0.564453 1.76657C0.564453 1.46329 0.684931 1.17243 0.899382 0.957976C1.11383 0.743524 1.40469 0.623047 1.70797 0.623047H5.71029C6.01357 0.623047 6.30442 0.743524 6.51888 0.957976C6.73333 1.17243 6.85381 1.46329 6.85381 1.76657C6.85381 3.19596 7.08251 4.56819 7.50561 5.84893C7.6314 6.24916 7.53992 6.69513 7.21973 7.01532L4.70399 9.53106Z",
    fill: "#EE1E12"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactPhone);
export default __webpack_public_path__ + "static/media/contact-phone.39319bb088914746056df39fc4dab01d.svg";
export { ForwardRef as ReactComponent };